import type { ClaimStatus, JobStatus } from "@agw/contracts";

export const qk = {
  me: ["me"] as const,
  jobs: (f: { storeId?: string; status?: JobStatus; claimStatus?: ClaimStatus; repId?: string }) => ["jobs", f] as const,
  jobsAll: ["jobs"] as const,
  job: (jobId: string) => ["job", jobId] as const,
  vin: (vin: string) => ["vin", vin] as const,
  opsQueue: ["ops", "queue"] as const,
  opsFailed: ["ops", "failed"] as const,
  jobPhotos: (jobId: string) => ["job", jobId, "photos"] as const,
  people: ["people"] as const,
  stores: ["stores"] as const,
  reports: (from: string, to: string) => ["reports", from, to] as const,
};
